module.exports = __webpack_public_path__ + "img/novakid.3c5dc95d.svg";